import { countries, getCountryDataList } from 'countries-list';
import { Business } from '../dto';
import { BusinessContextData } from '../context/BusinessContext';

export const Countries = getCountryDataList()
  .map((c) => ({
    value: c.iso2,
    label: c.name,
  }))
  .sort((a, b) => a.label.localeCompare(b.label));

export const getCountryName = (countryCode: string) => {
  return (countries as any)[countryCode].name;
};

export const getCurrencies = (business: BusinessContextData) => {
  return Object.values(business.currencies).map((c) => ({
    value: c.currencyCode,
    label: `${c.currencyName} (${c.currencyCode})`,
  }));
};
